export default __webpack_public_path__ + "static/media/Note_Light.8b3537c7.svg";